import { render, staticRenderFns } from "./VendedorShowData.vue?vue&type=template&id=0375fe17&"
import script from "./VendedorShowData.vue?vue&type=script&lang=js&"
export * from "./VendedorShowData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports